module.exports = __webpack_public_path__ + "img/img43.d010a382.png";